import React, { FC, useCallback, useMemo, useState } from "react";
import ArrowSub from "../../../assets/arrowDown.svg";
import Button from "../Button/Button";
import "./DropDownSelect.css"

export interface IListItemDropDown {
    itemName: string;
    id: number;
}

interface IDropDownSelectProps {
    id: number;
    listItem: IListItemDropDown[];
    currentChoise?: number;
    callBack: (id: number) => void;
    openDropDown: boolean;
}

const DropDownSelect: FC<IDropDownSelectProps> = ({
    id,
    listItem,
    currentChoise,
    callBack,
    openDropDown
}) => {
    const [open, setOpen] = useState<boolean>(false);

    const currentItem = useMemo(() => 
        listItem.find(item => item.id === currentChoise)?.itemName ?? "Выберите"
    , [listItem, currentChoise]);

    const handleOpenDropDown = useCallback(() => {
        if (openDropDown) {
            setOpen(prevOpen => !prevOpen);
        } else {
            callBack(-1);
        }
    }, [openDropDown, callBack]);

    const handleItemSelect = useCallback((itemId: number) => {
        callBack(itemId);
        setOpen(false);
    }, [callBack]);

    const dropdownItems = useMemo(() => 
        listItem.map(item => (
            <div 
                key={item.id}
                className="ui__component--drop__down--select__item" 
                onClick={() => handleItemSelect(item.id)}
            >
                <a id={`drop-item-${item.id}`}>{item.itemName}</a>
            </div>
        ))
    , [listItem, handleItemSelect]);

    const dropdownStyle = useMemo(() => ({
        display: open ? "flex" : "none"
    }), [open]);

    const buttonStyle = useMemo(() => ({
        transform: open ? "rotate(180deg)" : "none"
    }), [open]);

    return (
        <div className="ui__component--drop__down--select">
            <div className="ui__component--drop__down--select__name">
                <a style={{ padding: "5px", width: "100%" }}>
                    {currentItem}
                </a>
                <Button 
                    id={`drop-down-select-button-${id}`}
                    style={buttonStyle}
                    image={ArrowSub}
                    callBack={handleOpenDropDown}
                />
            </div>
            <div 
                className="ui__component--drop__down--select__items" 
                style={dropdownStyle}
            >
                {dropdownItems}
            </div>
        </div>
    );
}

export default React.memo(DropDownSelect);